// Helpers pure pentru intervale de calendar (timesheet/concedii), partajate de
// EmployeeDetails.vue și CompanyDetails.vue — erau duplicate byte-identic în ambele.
import { normalizeDateString, formatAsIsoDate } from "./holidayFormatting.mjs";

// Normalizează o selecție de interval (array, Date, string sau {start,end}) la o formă
// stabilă { start, end, hasStart, hasEnd } cu date ISO ordonate crescător.
export const normalizeRangeSelection = (value) => {
  if (!value) {
    return { start: "", end: "", hasStart: false, hasEnd: false };
  }

  let startValue = null;
  let endValue = null;

  if (Array.isArray(value)) {
    [startValue, endValue] = value;
  } else if (value instanceof Date || typeof value === "string") {
    startValue = value;
  } else if (typeof value === "object") {
    if ("start" in value || "end" in value) {
      startValue = value.start ?? null;
      endValue = value.end ?? null;
    }
  }

  const startIso = normalizeDateString(startValue);
  const endIso = normalizeDateString(endValue);

  if (startIso && endIso) {
    if (startIso <= endIso) {
      return { start: startIso, end: endIso, hasStart: true, hasEnd: true };
    }
    return { start: endIso, end: startIso, hasStart: true, hasEnd: true };
  }

  return {
    start: startIso || "",
    end: endIso || "",
    hasStart: Boolean(startIso),
    hasEnd: Boolean(endIso),
  };
};

// Intervalul implicit = luna curentă (prima zi → ultima zi), ca date ISO.
export const buildDefaultFillRange = () => {
  const today = new Date();
  const start = new Date(today.getFullYear(), today.getMonth(), 1);
  const end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  return {
    start_date: formatAsIsoDate(start),
    end_date: formatAsIsoDate(end),
  };
};
